
function StatusBadge({ status }) {
  const styles = {
    ACTIVO: ["#e4f6ec","#238456"],
    MOROSO: ["#fde9e9","#c74444"],
    PAGADO: ["#e6efff","#4168b7"],
    DEUDA: ["#fff2d9","#a16c12"],
    PAGO50: ["#e8efff","#4269bd"],
    REFINANCIADO: ["#eee9fb","#7254ad"],
  };
  const [backgroundColor,color] = styles[status] || ["#f0f1f3","#5d6470"];
  return <span className="cc-badge" style={{ backgroundColor, color }}>{status}</span>;
}
export default StatusBadge;
